import {IconChevronRight, IconNews} from "@tabler/icons-react";
import {useRef, useState} from "react";
import {useNavigate} from "react-router-dom";
import useNotificationsFeed from "../../../hooks/notifications/useNotificationsFeed";
import styles from "./HomeNewsCarousel.module.css";

const MiniCard = ({item}) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (item.link) navigate(item.link);
  };

  return (
    <div
      className={styles.card}
      onClick={handleClick}
      onKeyDown={e => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          handleClick();
        }
      }}
      role="button"
      tabIndex={0}
      aria-label={item.title}
    >
      <div className={styles.cardImage}>
        {item.image ? (
          <img
            src={item.image}
            alt=""
            className={styles.cardImg}
            loading="lazy"
            onError={e => {
              e.currentTarget.style.display = "none";
              e.currentTarget.nextElementSibling.style.display = "flex";
            }}
          />
        ) : null}
        <div
          className={styles.cardImgFallback}
          style={item.image ? {display: "none"} : undefined}
        >
          <IconNews size={20} />
        </div>
      </div>

      <div className={styles.cardBody}>
        <span className={styles.cardTitle}>{item.title}</span>
        {item.body && <span className={styles.cardSubtitle}>{item.body}</span>}
      </div>

      <div className={styles.cardArrow}>
        <IconChevronRight size={16} />
      </div>
    </div>
  );
};

const HomeNewsCarousel = () => {
  const {feed, isLoading} = useNotificationsFeed();
  const scrollRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);
  const dragState = useRef({startX: 0, scrollLeft: 0});

  const newsItems = feed.filter(item => item.type === "news");

  const handlePointerDown = e => {
    if (!scrollRef.current) return;
    if (e.pointerType === "touch") return;
    setIsDragging(true);
    dragState.current.startX = e.clientX;
    dragState.current.scrollLeft = scrollRef.current.scrollLeft;
    scrollRef.current.setPointerCapture(e.pointerId);
  };

  const handlePointerMove = e => {
    if (!isDragging || !scrollRef.current) return;
    const delta = e.clientX - dragState.current.startX;
    scrollRef.current.scrollLeft = dragState.current.scrollLeft - delta;
  };

  const handlePointerUp = () => {
    setIsDragging(false);
  };

  if (isLoading) {
    return (
      <div className={styles.section}>
        <div className={styles.track}>
          {[1, 2, 3].map(i => (
            <div
              key={i}
              className={styles.slide}
            >
              <div
                className={styles.skeleton}
                aria-hidden="true"
              >
                <div className={styles.skeletonImage} />
                <div className={styles.skeletonBody}>
                  <div className={styles.skeletonLine} />
                  <div className={styles.skeletonLineShort} />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  if (newsItems.length === 0) return null;

  return (
    <section
      className={styles.section}
      aria-label="Noticias destacadas"
    >
      <div
        className={styles.track}
        ref={scrollRef}
        onPointerDown={handlePointerDown}
        onPointerMove={handlePointerMove}
        onPointerUp={handlePointerUp}
        onPointerCancel={handlePointerUp}
      >
        {newsItems.map(item => (
          <div
            key={item.id}
            className={styles.slide}
          >
            <MiniCard item={item} />
          </div>
        ))}
      </div>
    </section>
  );
};

export default HomeNewsCarousel;
